module.exports = __webpack_public_path__ + "img/digital_space_bg_bottom2.fe220f7f.svg";